import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Add auth token interceptor
api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken && accessToken !== 'null' && accessToken !== 'undefined') {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const apiService = {
  get: (url) => api.get(url).then(res => res.data),
  post: (url, data) => api.post(url, data).then(res => res.data),
  put: (url, data) => api.put(url, data).then(res => res.data),
  delete: (url) => api.delete(url).then(res => res.data),
};

const recipientService = {
  /**
   * Get all recipients for a campaign
   */
  async getRecipients(campaignId) {
    try {
      const response = await apiService.get(`/marketing/${campaignId}/recipients`);
      return response.recipients || [];
    } catch (error) {
      console.error('Error fetching recipients:', error);
      throw error;
    }
  },

  /**
   * Add recipients to a campaign (single or bulk)
   */
  async addRecipients(campaignId, recipients) {
    try {
      // If single recipient, wrap in array
      const recipientsArray = Array.isArray(recipients) ? recipients : [recipients];
      
      const response = await apiService.post(`/marketing/${campaignId}/recipients`, recipientsArray);
      return response;
    } catch (error) {
      console.error('Error adding recipients:', error);
      throw error;
    }
  },

  /**
   * Update a recipient
   */
  async updateRecipient(campaignId, recipientId, recipientData) {
    try {
      const response = await apiService.put(`/marketing/${campaignId}/recipients/${recipientId}`, recipientData);
      return response;
    } catch (error) {
      console.error('Error updating recipient:', error);
      throw error;
    }
  },

  /**
   * Delete a recipient
   */
  async deleteRecipient(campaignId, recipientId) {
    try {
      const response = await apiService.delete(`/marketing/${campaignId}/recipients/${recipientId}`);
      return response;
    } catch (error) {
      console.error('Error deleting recipient:', error);
      throw error;
    }
  },

  /**
   * Import recipients from CSV
   */
  async importFromCSV(campaignId, csvFile) {
    try {
      // Parse CSV file
      const text = await csvFile.text();
      const lines = text.split('\n').filter(line => line.trim());
      const headers = lines[0].split(',').map(h => h.trim());
      
      const recipients = [];
      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(',').map(v => v.trim());
        const recipient = {};
        headers.forEach((header, index) => {
          recipient[header.toLowerCase()] = values[index] || '';
        });
        recipients.push(recipient);
      }

      return await this.addRecipients(campaignId, recipients);
    } catch (error) {
      console.error('Error importing CSV:', error);
      throw error;
    }
  },

  /**
   * Import recipients from jobs-monitor results
   */
  async importFromJobs(campaignId, jobIds) {
    try {
      // This would fetch job results and convert to recipients
      // For now, return a placeholder
      // TODO: Implement actual job result fetching
      throw new Error('Import from jobs not yet implemented');
    } catch (error) {
      console.error('Error importing from jobs:', error);
      throw error;
    }
  }
};

export default recipientService;

